import { render } from "./MailLogView.vue?vue&type=template&id=b146d88c&scoped=true"
import script from "./MailLogView.vue?vue&type=script&lang=js"
export * from "./MailLogView.vue?vue&type=script&lang=js"

import "./MailLogView.vue?vue&type=style&index=0&id=b146d88c&scoped=true&lang=css"

import exportComponent from "/home/Daten/Entwicklung/repositories/bdl_ui/de.stone.bdl.management.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b146d88c"]])

export default __exports__